import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

import { paginate } from '../../utils/array';
import { Paginate, PaginationData } from './pagination.types';

@Component({
  selector: 'cohrex-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PaginationComponent implements OnChanges {
  private _paginationData?: PaginationData = {
    current_page: 0,
    from: 0,
    last_page: 0,
    per_page: 0,
    to: 0,
    total: 0
  };
  paginationParam = {};
  @Input()
  set paginationData(value: PaginationData | undefined) {
    this._paginationData = value;
  }
  get paginationData(): PaginationData | undefined {
    return this._paginationData;
  }

  @Output()
  pageChanged = new EventEmitter<number>();

  paginate?: Paginate;

  ngOnChanges(changes: SimpleChanges): void {
    this.paginate = paginate(
      this.paginationData?.total!,
      this.paginationData?.current_page!,
      this.paginationData?.per_page!,
      this.paginationData?.last_page!
    );
    this.paginationParam = {
      from: (this.paginate?.startIndex ?? 0) + 1,
      to: (this.paginate?.endIndex ?? 0) + 1,
      of: this.paginate?.totalItems
    };
  }

  setPage(page: number) {
    this.pageChanged.emit(page);
  }
}
